module.exports = __webpack_public_path__ + "static/media/C11.4bf1fa86.jpg";